import { CREATE_POST_DATA } from "./types";

export const storeCreateAdDetails = (data) => {
  return {
    type: CREATE_POST_DATA,
    payload: data,
  };
};
